import { useEffect } from 'react';
import axios from 'axios';
import { useConfig } from '../config';

let sendRefererCalled = false;

export function useSendReferer() {
	const { api } = useConfig();

	useEffect(() => {
		let referrer = document.referrer;
		if (referrer.indexOf(location.protocol + '//' + location.hostname) === 0) {
			referrer = '';
		}
		if ((referrer != '' || document.location.search != '') && !sendRefererCalled) {
			sendRefererCalled = true;
			const payload = {
				referrer: referrer,
				search: document.location.search,
				path: document.location.pathname,
			};
			axios
				.post(`${api}entry.json`, payload, {
					withCredentials: true,
				})
				// telemetry: nobody is waiting for it, but a rejection has to be taken somewhere
				.catch(() => undefined);
		}
	}, []);
}
